/*
 * COPYRIGHT 2022,2023 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 *
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { ManageAssetPoolsPageStyles} from './ManageAssetPoolsPageStyles';
import ButtonPanel from '../buttonpanel/ButtonPanel';
import { ColumnHeading, DateUtils, DropDownButton, ListView, TableView } from 'yospace-ui-components';
import EnvironmentView from '../environmentview/EnvironmentView';

const PromotionFields = Object.freeze([
    new TableView.Field("ID", "id"),
    new TableView.Field("Type", "type"),
    new TableView.Field("Group", "group"),
    new TableView.Field("Name", "name")
])
class PromotionProperties extends Component {
    render () {
        let desc = this.props.data ? this.props.data.description : '-';

        return (
            <div style = { { backgroundColor: '#000000', whiteSpace: 'pre-line', fontWeight: '400', fontSize: '13px', padding: '10px 5px 10px 10px' } } >
                <div>
                    { desc }
                </div>
                <div style= { { padding: '20px 0px 0px 0px', borderColor: 'black' } } >
                    <TableView
                        values={ this.props.data.usedBy }
                        fields = { PromotionFields }
                        noImport = { true }
                        title = "USED BY"
                    />
                </div>
            </div>
        )
    }
}

// Displays a number with formatting
class NumberView extends Component {
    render() {
        let num = this.props.data ? this.props.data.toLocaleString() : '-';

        return (
            <div>
                { num }
            </div>
        )
    }
}

class DateView extends Component {
    // Converts month number to string representation.
    getMonth(month) {
        if (Number.isNaN(month) || month < 1 || month > 12) {
            return null;
        }
        let arr = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];

        return arr[month - 1];
    }

    parseDate() {
        let ret = "-";
        if (this.props.data) {
            // Assuming an epoch time or ISO8601-compliant string
            let date = new Date(this.props.data);
            let month = this.getMonth(date.getMonth());
            if (month) {
                return date.getDay() + " " + month + " " + date.getFullYear();
            }
        }

        return ret;
    }

    render() {
        return (
            <div>
                { this.parseDate() }
            </div>
        )
    }
}

class TimeDeltaView extends Component {
    render() {
        return (
            <div>
                { DateUtils.getTimeLapsed(this.props.data) }
            </div>
        )
    }
}

TimeDeltaView.propTypes = {
    data: PropTypes.object,
    field: PropTypes.string
}

const COLUMN_IDS = Object.freeze({
    ID: 0,
    GROUP: 1,
    NAME: 2,
    ITEMS: 3,
    LAST_UPDATE: 4,
    FIRST_INGESTION: 5,
    HOSTED_BY: 6,
    STATUS: 7
});

const LISTVIEW_COLUMNS = Object.freeze([
    new ListView.Column(COLUMN_IDS.ID, "ID", "id", null, { width: '1%' }, { expandable: true }, null, { searchType: ColumnHeading.SearchType.TEXT } ),
    new ListView.Column(COLUMN_IDS.GROUP, "Group", "group", null, { maxWidth: '20px' }, null, null, null),
    new ListView.Column(COLUMN_IDS.NAME, "Name", "name", null, { maxWidth: '80px' }, null, null, null),
    new ListView.Column(COLUMN_IDS.ITEMS, "Items", "numItems", React.createElement(NumberView), { maxWidth: '30px' }, null, null, null),
    new ListView.Column(COLUMN_IDS.LAST_UPDATE, "Last Update", "lastUpdate", React.createElement(TimeDeltaView), { maxWidth: '35px' }, null, null, null),
    new ListView.Column(COLUMN_IDS.FIRST_INGESTION, "First Ingestion", "firstIngestion", React.createElement(DateView), { maxWidth: '40px' }, null, null, null),
    new ListView.Column(COLUMN_IDS.HOSTED_BY, "Hosted By", "hostedBy", null, { maxWidth: '30px' }, null, null, null ),
    new ListView.Column(COLUMN_IDS.STATUS, "Status", "status", React.createElement(EnvironmentView), { width: '1%' }, null, null, null)
]);

class ManageAssetPoolsPage extends Component {
    constructor(props) {
        super(props);

        this.state = { pools: [] };
    }

    componentDidMount() {
        // Set dummy data for now
        let pools = [
            {
                id: "123456790ABC",
                group: "News",
                name: "ID3 Testing",
                description: "This is the description of the promotion as set in the Promotion properties.\nIt extends this far and will also honour newlines.",
                numItems: 9999999,
                lastUpdate: Date.now() - (3 * 24 * 60 * 60 * 1000),
                firstIngestion: Date.now(),
                hostedBy: "AAM",
                status: "PRD",
                usedBy: [
                    {
                        id: 12371289123,
                        type: "VOD",
                        group: "Brand X/VOD",
                        name: "VOD Clips"
                    },
                    {
                        id: "Data",
                        type: "AMS",
                        group: "Brand X/AMS",
                        name: "Advance Bidding AMS"
                    },
                    {
                        id: "Data",
                        type: "Live Streaming",
                        group: "Brand X/Live",
                        name: "Sports 1"
                    }
                ]
            },
            {
                id: "123456791ABC",
                group: "News",
                name: "ID3 Testing",
                description: "This is the description of the promotion as set in the Promotion properties.\nIt extends this far and will also honour newlines.",
                numItems: 9999999,
                lastUpdate: Date.now() - (3 * 24 * 60 * 60 * 1000),
                firstIngestion: Date.now(),
                hostedBy: "AAM",
                status: "PRD",
                usedBy: [
                    {
                        id: 12371289123,
                        type: "VOD",
                        group: "Brand X/VOD",
                        name: "VOD Clips"
                    },
                    {
                        id: "Data",
                        type: "AMS",
                        group: "Brand X/AMS",
                        name: "Advance Bidding AMS"
                    },
                    {
                        id: "Data",
                        type: "Live Streaming",
                        group: "Brand X/Live",
                        name: "Sports 1"
                    }
                ]
            },
            {
                id: "123456792ABC",
                group: "News",
                name: "STG: Fox Media: Sports - Blockout",
                description: "This is the description of the promotion as set in the Promotion properties.\nIt extends this far and will also honour newlines.",
                numItems: 9999999,
                lastUpdate: Date.now() - (3 * 24 * 60 * 60 * 1000),
                firstIngestion: Date.now(),
                hostedBy: "AAM",
                status: "PRD",
                usedBy: [
                    {
                        id: 12371289123,
                        type: "VOD",
                        group: "Brand X/VOD",
                        name: "VOD Clips"
                    },
                    {
                        id: "Data",
                        type: "AMS",
                        group: "Brand X/AMS",
                        name: "Advance Bidding AMS"
                    },
                    {
                        id: "Data",
                        type: "Live Streaming",
                        group: "Brand X/Live",
                        name: "Sports 1"
                    }
                ]
            },
            {
                id: "123456793ABC",
                group: "News",
                name: "STG: Fox Media: Sports - Blockout - V3 - 123456789ABC",
                description: "This is the description of the promotion as set in the Promotion properties.\nIt extends this far and will also honour newlines.",
                numItems: 9999999,
                lastUpdate: Date.now() - (3 * 24 * 60 * 60 * 1000),
                firstIngestion: Date.now(),
                hostedBy: "AAM",
                status: "PRD",
                usedBy: [
                    {
                        id: 12371289123,
                        type: "VOD",
                        group: "Brand X/VOD",
                        name: "VOD Clips"
                    },
                    {
                        id: "Data",
                        type: "AMS",
                        group: "Brand X/AMS",
                        name: "Advance Bidding AMS"
                    },
                    {
                        id: "Data",
                        type: "Live Streaming",
                        group: "Brand X/Live",
                        name: "Sports 1"
                    }
                ]
            },
            {
                id: "123456794ABC",
                group: "News",
                name: "ID3 Testing",
                description: "This is the description of the promotion as set in the Promotion properties.\nIt extends this far and will also honour newlines.",
                numItems: 9999999,
                lastUpdate: Date.now() - (3 * 24 * 60 * 60 * 1000),
                firstIngestion: Date.now(),
                hostedBy: "AAM",
                status: "PRD",
                usedBy: [
                    {
                        id: 12371289123,
                        type: "VOD",
                        group: "Brand X/VOD",
                        name: "VOD Clips"
                    },
                    {
                        id: "Data",
                        type: "AMS",
                        group: "Brand X/AMS",
                        name: "Advance Bidding AMS"
                    },
                    {
                        id: "Data",
                        type: "Live Streaming",
                        group: "Brand X/Live",
                        name: "Sports 1"
                    }
                ]
            },
            {
                id: "123456795ABC",
                group: "News",
                name: "ID3 Testing",
                description: "This is the description of the promotion as set in the Promotion properties.\nIt extends this far and will also honour newlines.",
                numItems: 9999999,
                lastUpdate: Date.now() - (3 * 24 * 60 * 60 * 1000),
                firstIngestion: Date.now(),
                hostedBy: "AAM",
                status: "PRD",
                usedBy: [
                    {
                        id: 12371289123,
                        type: "VOD",
                        group: "Brand X/VOD",
                        name: "VOD Clips"
                    },
                    {
                        id: "Data",
                        type: "AMS",
                        group: "Brand X/AMS",
                        name: "Advance Bidding AMS"
                    },
                    {
                        id: "Data",
                        type: "Live Streaming",
                        group: "Brand X/Live",
                        name: "Sports 1"
                    }
                ]
            },
            {
                id: "123456796ABC",
                group: "News",
                name: "ID3 Testing",
                description: "This is the description of the promotion as set in the Promotion properties.\nIt extends this far and will also honour newlines.",
                numItems: 9999999,
                lastUpdate: Date.now() - (3 * 24 * 60 * 60 * 1000),
                firstIngestion: Date.now(),
                hostedBy: "AAM",
                status: "PRD",
                usedBy: [
                    {
                        id: 12371289123,
                        type: "VOD",
                        group: "Brand X/VOD",
                        name: "VOD Clips"
                    },
                    {
                        id: "Data",
                        type: "AMS",
                        group: "Brand X/AMS",
                        name: "Advance Bidding AMS"
                    },
                    {
                        id: "Data",
                        type: "Live Streaming",
                        group: "Brand X/Live",
                        name: "Sports 1"
                    }
                ]
            },
            {
                id: "123456797ABC",
                group: "News",
                name: "ID3 Testing",
                description: "This is the description of the promotion as set in the Promotion properties.\nIt extends this far and will also honour newlines.",
                numItems: 9999999,
                lastUpdate: Date.now() - (3 * 24 * 60 * 60 * 1000),
                firstIngestion: Date.now(),
                hostedBy: "AAM",
                status: "PRD",
                usedBy: [
                    {
                        id: 12371289123,
                        type: "VOD",
                        group: "Brand X/VOD",
                        name: "VOD Clips"
                    },
                    {
                        id: "Data",
                        type: "AMS",
                        group: "Brand X/AMS",
                        name: "Advance Bidding AMS"
                    },
                    {
                        id: "Data",
                        type: "Live Streaming",
                        group: "Brand X/Live",
                        name: "Sports 1"
                    }
                ]
            },
            {
                id: "123456798ABC",
                group: "News",
                name: "ID3 Testing",
                description: "This is the description of the promotion as set in the Promotion properties.\nIt extends this far and will also honour newlines.",
                numItems: 9999999,
                lastUpdate: Date.now() - (3 * 24 * 60 * 60 * 1000),
                firstIngestion: Date.now(),
                hostedBy: "AAM",
                status: "PRD",
                usedBy: [
                    {
                        id: 12371289123,
                        type: "VOD",
                        group: "Brand X/VOD",
                        name: "VOD Clips"
                    },
                    {
                        id: "Data",
                        type: "AMS",
                        group: "Brand X/AMS",
                        name: "Advance Bidding AMS"
                    },
                    {
                        id: "Data",
                        type: "Live Streaming",
                        group: "Brand X/Live",
                        name: "Sports 1"
                    }
                ]
            }
        ];

        this.setState({
            pools: pools
        })
    }

    render() {
        return (
            <div>
                <div style = { ManageAssetPoolsPageStyles.getTopPanelContainer() } >
                    <div style = { ManageAssetPoolsPageStyles.getTitle() } >
                        Manage Asset Pools
                    </div>
                    <div style = { ManageAssetPoolsPageStyles.getButtonsContainer()}  >
                        <DropDownButton title = "No Filter" width = "210" >
                            <DropDownButton.ItemView name = "Test" />
                        </DropDownButton>
                        <ButtonPanel />
                    </div>
                </div>
                <div style = { ManageAssetPoolsPageStyles.getContentContainer() } >
                    <ListView
                        columns = { LISTVIEW_COLUMNS }
                        data = { this.state.pools }
                        extraComponent = { React.createElement(PromotionProperties) }
                    />
                </div>
            </div>
        )
    }
}

export default ManageAssetPoolsPage;